import React,{useState,useEffect} from "react";
  import { useRouteMatch,Switch, Route } from "react-router-dom";

  import { useDispatch,useSelector } from 'react-redux';
import Profile from "../Dashboard/Profile/Profile";
import CRMLogin from "./CRMlogin";
  
import { checkLeadManagerLoginStatus } from "../../store/actions/CRM/checkLeadManagerLoginStatus";
import Loading from "../Loading/Loading";
import CRMDashboard from "./CRMDashboard";
  
import './CRM.css'
import CreateLead from "./CreateLead";
import Navber from "../../Navbar/UserMenu";
import { ChevronLeft, X } from "lucide-react";
import CRMnavber from "./CRMnavbar";
import SearchLeads from "./SearchLeads";
import SearchLeadsScroll from "./SearchLeadsScroll";

import UploadImgToWP from "../Create/UploadImgToWP";
 const CRM = ()=>{
   // const userdata = useSelector((state)=>state?.user?.user?.user);
   const dispatch = useDispatch();
    
          const [open , setOpen]=useState(false);
   const [loader , setLoader] =useState({status:false});
   const [statusData , setStatusData] =useState({status:false});
 const token = useSelector((state)=>state?.course?.course?.token);
 const currentToken = useSelector((state)=>state?.user?.user?.token);
   const mainMenuStatus = useSelector((state)=>state?.app?.mainMenuStatus);
 
    const {url,path} =useRouteMatch();
     
     
   const CRMtoken= useSelector((state)=>state?.crmData?.crmPass);
   
   const userdata = useSelector((state)=>state?.user?.user);
 
  useEffect(() => {
    
  setLoader({status:true});
  const LeadManagerLoginStatusData= {userEmail:userdata?.user_email,CRMtoken:CRMtoken,currentToken:currentToken}
     const user = dispatch(checkLeadManagerLoginStatus(LeadManagerLoginStatusData));
     /* get response as Promise   */
     user.then(response => {
     // pop up with message 
     //   console.log(response)
     setStatusData(response)
      setInterval(()=>{
       // hide poped message 
       
      },3000)
      
  
   
   setLoader({status:false});
   
   
   
     }).catch(error => {
       
   /* resetting Login input Fields */
   //setLogin({user_email:'',user_pass:""
   
   // })
   setLoader({status:false});
       console.error(error);
     });
    
 
 
 
   }, []);
  
  

    return <>

<div className={`${mainMenuStatus?"outer-all ":"outer-all-small"} bgGradient1` } style={{zIndex:"99"}} >
  <div></div>
<div className = {` outer-left ${open?"outer-left-style":"outer-right-style"} `}style={{zIndex:"99"}}   id="outer-left">
  
<div className="">
       
{
              open?
              <div className="outer-left-close" style={{marginTop:"-20px"}} onClick={()=>setOpen(false)}><X/></div>
                :
            ""
              }
              
 
       <CRMnavber  baseUrl={url}/>
    </div>
    
    
    </div>
    <div className="outer-right">
        <div className="content-topk">
              <div className="">
             
        
        
                
                {
              open?
             ""   :
            <div className=" outer-left-open" onClick={()=>setOpen(true)}>
                            <ChevronLeft/></div>
              }
             </div>
           </div> 

    

<Switch>
   <Route path={`${url}/crm-login`}>
   <CRMLogin baseUrl={url}/>

</Route>



<Route  path={`${url}/dashboard`}>
   

<CRMDashboard baseUrl={url}/>


    </Route>
    <Route  path={`${url}/new-lead`}>
   <CreateLead baseUrl={url}/>



    </Route><Route  path={`${url}/search`}>
   <SearchLeads baseUrl={url}/>
{/* <UploadImgToWP/> */}
    {/* <SearchLeadsScroll  baseUrl={url} /> */}

    </Route>

<Route exact path={`${url}`}>
<CRMLogin baseUrl={url}/>
    </Route>
</Switch>
       
            
                
<div className="content-bottom">

</div>
</div>
</div>

<div  style={{"height":"10px"}}>
            
        </div>

   
    </>

}
export default CRM;
